module.exports = __webpack_public_path__ + "img/phone1-icon.e3d3638b.png";